import * as Yup from "yup";

export function initialValues(event) {
  return {
    title: event?.title || "",
    description: event?.description || "",
    content: event?.content || "",
    eventDate: event?.eventDate ? new Date(event.eventDate).toISOString().slice(0, 16) : "",
    endDate: event?.endDate ? new Date(event.endDate).toISOString().slice(0, 16) : "",
    location: event?.location || "",
    isVirtual: event?.isVirtual || false,
    virtualLink: event?.virtualLink || "",
    imageUrl: event?.imageUrl || "",
    imageFile: null,
    status: event?.status || "draft",
    featured: event?.featured || false,
    maxAttendees: event?.maxAttendees || "",
    registrationRequired: event?.registrationRequired || false,
    registrationDeadline: event?.registrationDeadline 
      ? new Date(event.registrationDeadline).toISOString().slice(0, 16) 
      : "",
    targetAudience: event?.targetAudience || "all",
    categoryId: event?.categoryId || "",
    academicCycleId: event?.academicCycleId || "",
    gradeId: event?.gradeId || "",
    tags: event?.tags ? (typeof event.tags === "string" ? event.tags : JSON.stringify(event.tags)) : "[]",
    slug: event?.slug || "",
    metaDescription: event?.metaDescription || "",
    notifyMode: "none",
    notifyLevelId: null,
    notifyGradeId: null,
  };
}

export function validationSchema() {
  return Yup.object({
    title: Yup.string().required("El título es obligatorio"),
    description: Yup.string().required("La descripción es obligatoria"),
    content: Yup.string().required("El contenido es obligatorio"),
    eventDate: Yup.date()
      .required("La fecha del evento es obligatoria")
      .typeError("Fecha inválida"),
    endDate: Yup.date()
      .min(Yup.ref("eventDate"), "La fecha de fin debe ser posterior a la fecha de inicio")
      .nullable(),
    location: Yup.string().when("isVirtual", {
      is: false,
      then: (schema) => schema.required("La ubicación es obligatoria para eventos presenciales"),
      otherwise: (schema) => schema,
    }),
    virtualLink: Yup.string().when("isVirtual", {
      is: true,
      then: (schema) => schema.url("Debe ser una URL válida").required("El enlace virtual es obligatorio"),
      otherwise: (schema) => schema,
    }),
    status: Yup.string()
      .oneOf(["draft", "published", "cancelled", "completed"], "Estado inválido")
      .required("El estado es obligatorio"),
    targetAudience: Yup.string()
      .oneOf(["all", "students", "teachers", "parents", "public"], "Audiencia inválida")
      .required("La audiencia objetivo es obligatoria"),
    categoryId: Yup.number()
      .required("La categoría es obligatoria")
      .typeError("Seleccione una categoría válida"),
    slug: Yup.string().matches(/^[a-z0-9]+(-[a-z0-9]+)*$/, {
      message: "Solo minúsculas, números y guiones (ej. mi-evento)",
      excludeEmptyString: true,
    }),
    maxAttendees: Yup.number()
      .positive("Debe ser un número positivo")
      .integer("Debe ser un número entero")
      .nullable(),
    registrationDeadline: Yup.date()
      .max(Yup.ref("eventDate"), "La fecha límite debe ser anterior al evento")
      .nullable()
      .when("registrationRequired", {
        is: true,
        then: (schema) => schema.required("La fecha límite es obligatoria si el registro es requerido"),
        otherwise: (schema) => schema,
      }),
    notifyMode: Yup.string().oneOf(
      ["none", "all", "level", "grade"],
      "Audiencia inválida"
    ),
    // El público a notificar solo es relevante (y solo se envía) cuando el
    // evento se guarda como Publicado; en cualquier otro estado no debe
    // exigirse, aunque hayan quedado valores de una selección anterior.
    notifyLevelId: Yup.number()
      .typeError("Seleccione un nivel válido")
      .when(["notifyMode", "status"], {
        is: (notifyMode, status) => notifyMode === "level" && status === "published",
        then: (schema) => schema.required("Seleccione un nivel"),
        otherwise: (schema) => schema.nullable(),
      }),
    notifyGradeId: Yup.number()
      .typeError("Seleccione un grado válido")
      .when(["notifyMode", "status"], {
        is: (notifyMode, status) => notifyMode === "grade" && status === "published",
        then: (schema) => schema.required("Seleccione un grado"),
        otherwise: (schema) => schema.nullable(),
      }),
  });
}
